import axios from "axios";
import {
  clearTokens,
  getAccessToken,
  getRefreshToken,
  setTokens,
} from "../utils/tokenStorage";

// 1) Préparer la base de l'URL
const FALLBACK_BASE_URL = "http://localhost:8000";
const RAW_ENV_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.API_BASE_URL ||
  FALLBACK_BASE_URL;
  

const normalizeBaseUrl = (url) => url.replace(/\/+$/, "");
const API_BASE_URL = normalizeBaseUrl(RAW_ENV_BASE_URL);
const API_ROOT = `${API_BASE_URL}/api`;

// 2) Créer le client Axios
const axiosClient = axios.create({
  baseURL: API_ROOT,
  headers: { "Content-Type": "application/json" },
  timeout: 10000,
});

// 3) Ajouter automatiquement le token d'accès
axiosClient.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// 4) Centraliser les réactions aux erreurs
const removeTokensAndRedirect = () => {
  clearTokens();
  window.location.href = "/login";
};

const requestNewAccessToken = async () => {
  const refreshToken = getRefreshToken();
  if (!refreshToken) return null;

  const response = await axios.post(`${API_ROOT}/token/refresh/`, {
    refresh: refreshToken,
  });

  return response.data.access;
};

axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const isUnauthorized = error.response?.status === 401;

    if (!isUnauthorized || originalRequest._retry) {
      return Promise.reject(error);
    }

    originalRequest._retry = true;

    try {
      const newAccessToken = await requestNewAccessToken();
      if (!newAccessToken) {
        removeTokensAndRedirect();
        return Promise.reject(error);
      }

      setTokens({ access: newAccessToken });
      originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
      return axiosClient(originalRequest);
    } catch (refreshError) {
      console.error("Erreur de refresh :", refreshError);
      removeTokensAndRedirect();
      return Promise.reject(refreshError);
    }
  }
);

export default axiosClient;
